/* Korean signin UI delegates authentication and session creation to Ghost Members. */
(function () {
  const surface = document.querySelector('[data-member-signin]');
  if (!surface) return;

  const form = surface.querySelector('.member-signin-form');
  const emailInput = form && form.querySelector('input[name="email"]');
  const feedback = surface.querySelector('[data-member-signin-feedback]');
  const submitButton = surface.querySelector('.member-signin-submit');
  const inboxLink = surface.querySelector('[data-member-signin-inbox-link]');
  const inboxIcon = surface.querySelector('[data-member-signin-inbox-icon]');
  const inboxLabel = surface.querySelector('[data-member-signin-inbox-label]');
  const otcMount = surface.querySelector('[data-member-signin-otc-mount]');
  const otcTemplate = surface.querySelector('template[data-member-signin-otc-template]');
  if (!form || !emailInput || !feedback || !submitButton || !otcMount || !otcTemplate) return;

  let submitting = false;
  let verifying = false;
  let redirecting = false;
  let otcRef = null;
  let hasSent = false;
  let otcForm = null;
  let otcInput = null;
  let otcFeedback = null;
  let otcSubmitButton = null;
  const providerLabels = {
    gmail: 'Gmail에서 이메일 확인',
    outlook: 'Outlook에서 이메일 확인',
    yahoo: 'Yahoo에서 이메일 확인',
    proton: 'Proton Mail에서 이메일 확인',
    icloud: 'iCloud Mail에서 이메일 확인',
    hey: 'HEY에서 이메일 확인',
    aol: 'AOL Mail에서 이메일 확인',
    mailru: 'Mail.ru에서 이메일 확인',
    feedbin: 'Feedbin에서 이메일 확인',
    'dev-mailpit': '이메일 확인',
    naver: '네이버 메일에서 이메일 확인',
    daum: '다음 메일에서 이메일 확인'
  };
  const providerIcons = {
    gmail: 'gmail.svg',
    outlook: 'outlook.svg',
    icloud: 'icloud.svg',
    naver: 'naver.svg?v=20261002-1',
    daum: 'daum.svg?v=20261002-2'
  };
  const providerSuccessMessages = {
    gmail: 'Gmail로 로그인 정보를 보냈습니다.',
    outlook: 'Outlook으로 로그인 정보를 보냈습니다.',
    icloud: 'iCloud Mail로 로그인 정보를 보냈습니다.',
    naver: '네이버 메일로 로그인 정보를 보냈습니다.',
    daum: '다음 메일로 로그인 정보를 보냈습니다.'
  };
  const getKoreanMailboxFallback = (email) => {
    const domain = String(email || '').trim().toLowerCase().split('@').pop();
    if (domain === 'naver.com') {
      return {provider: 'naver', desktop: 'https://mail.naver.com/', android: 'https://mail.naver.com/'};
    }
    if (domain === 'daum.net' || domain === 'hanmail.net') {
      return {provider: 'daum', desktop: 'https://mail.daum.net/', android: 'https://mail.daum.net/'};
    }
    return null;
  };
  const isAndroidChrome = () => {
    const nav = window.navigator || {};
    const android = typeof nav.userAgentData?.platform === 'string'
      ? nav.userAgentData.platform === 'Android'
      : /android/i.test(nav.userAgent || '');
    return android && /chrome/i.test(nav.userAgent || '');
  };
  const setInboxLink = (links) => {
    if (!inboxLink) return;
    inboxLink.hidden = true;
    inboxLink.removeAttribute('href');
    if (inboxIcon) inboxIcon.replaceChildren();
    if (inboxLabel) inboxLabel.textContent = '';
    // Ghost remains authoritative. Local known-domain links are only a fallback
    // when Ghost did not return inboxLinks at all; provider/MX detection stays server-owned.
    const resolvedLinks = links == null ? getKoreanMailboxFallback(emailInput.value) : links;
    const provider = resolvedLinks && typeof resolvedLinks.provider === 'string' ? resolvedLinks.provider : '';
    const value = resolvedLinks && (isAndroidChrome() ? resolvedLinks.android : resolvedLinks.desktop);
    const successMessage = providerSuccessMessages[provider] || '';
    if (typeof value !== 'string') {
      inboxLink.hidden = true;
      inboxLink.removeAttribute('href');
      return successMessage;
    }
    let url;
    try {
      url = new URL(value);
    } catch (_) {
      inboxLink.hidden = true;
      inboxLink.removeAttribute('href');
      return successMessage;
    }
    const allowedProtocol = url.protocol === 'https:' || (isAndroidChrome() && url.protocol === 'intent:');
    if (!allowedProtocol) {
      inboxLink.hidden = true;
      inboxLink.removeAttribute('href');
      return successMessage;
    }
    inboxLink.href = url.href;
    if (inboxLabel) inboxLabel.textContent = providerLabels[provider] || '이메일 확인';
    const iconPath = providerIcons[provider];
    if (iconPath && inboxIcon) {
      const image = document.createElement('img');
      image.src = `/assets/images/mail-providers/${iconPath}`;
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');
      inboxIcon.replaceChildren(image);
    }
    inboxLink.hidden = false;
    return successMessage;
  };
  const markAsResend = () => {
    hasSent = true;
    submitButton.classList.remove('billing-primary-action');
    submitButton.classList.add('billing-action');
    submitButton.classList.add('billing-action-secondary');
    submitButton.textContent = '로그인 이메일 다시 보내기';
  };
  const setFeedback = (message, isError) => {
    feedback.textContent = message;
    feedback.classList.toggle('billing-error', Boolean(isError));
  };
  const setOtcFeedback = (message, isError) => {
    if (!otcFeedback) return;
    otcFeedback.textContent = message;
    otcFeedback.classList.toggle('billing-error', Boolean(isError));
  };
  const mountOtcSection = () => {
    const content = otcTemplate.content.cloneNode(true);
    otcMount.replaceChildren(content);
    otcForm = otcMount.querySelector('[data-member-signin-otc-form]');
    otcInput = otcForm && otcForm.querySelector('input[name="otc"]');
    otcFeedback = otcMount.querySelector('[data-member-signin-otc-feedback]');
    otcSubmitButton = otcForm && otcForm.querySelector('.member-signin-otc-submit');
    if (!otcForm || !otcInput || !otcFeedback || !otcSubmitButton) {
      otcMount.replaceChildren();
      otcRef = null;
      return false;
    }

    otcInput.addEventListener('input', () => {
      otcInput.value = otcInput.value.replace(/[^0-9]/g, '').slice(0, 6);
      otcSubmitButton.disabled = otcInput.value.length !== 6 || verifying;
      setOtcFeedback('', false);
    });
    otcForm.addEventListener('submit', submitOtc);
    return true;
  };
  const getIntegrityToken = async () => {
    const response = await fetch('/members/api/integrity-token/', {
      method: 'GET',
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('integrity_request_failed');
    return response.text();
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submitting) return;

    emailInput.value = emailInput.value.trim();
    if (!emailInput.checkValidity()) {
      setFeedback('올바른 이메일 주소를 입력해 주세요.', true);
      emailInput.focus();
      return;
    }

    submitting = true;
    submitButton.disabled = true;
    submitButton.textContent = '보내는 중...';
    setFeedback('', false);
    try {
      const integrityToken = await getIntegrityToken();
      const response = await fetch('/members/api/send-magic-link/', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          email: emailInput.value,
          emailType: 'signin',
          integrityToken,
          includeOTC: true
        })
      });

      if (response.status === 429) {
        setFeedback('요청이 많습니다. 잠시 후 다시 시도해 주세요.', true);
      } else if (!response.ok) {
        setFeedback('로그인 링크를 요청하지 못했습니다. 이메일 주소를 확인한 뒤 다시 시도해 주세요.', true);
      } else {
        let result = {};
        try {
          result = await response.json();
        } catch (_) {
          // Keep the existing magic-link fallback if the optional OTC reference is absent.
        }

        const providerSuccessMessage = setInboxLink(result.inboxLinks);
        markAsResend();
        if (typeof result.otc_ref === 'string' && result.otc_ref.length > 0) {
          otcRef = result.otc_ref;
          if (mountOtcSection()) {
            setFeedback(providerSuccessMessage || '입력한 이메일로 로그인 링크와 인증 코드를 보냈습니다.', false);
            otcInput.focus();
          } else {
            setFeedback('입력한 이메일로 로그인 링크를 보냈습니다. 이메일을 확인해 주세요.', false);
          }
        } else {
          otcRef = null;
          otcMount.replaceChildren();
          otcForm = null;
          otcInput = null;
          otcFeedback = null;
          otcSubmitButton = null;
          setFeedback(providerSuccessMessage || '입력한 주소가 회원 계정에 등록되어 있다면 로그인 링크를 받을 수 있습니다. 이메일을 확인해 주세요.', false);
        }
      }
    } catch (_) {
      setFeedback('로그인 링크를 요청하지 못했습니다. 잠시 후 다시 시도해 주세요.', true);
    } finally {
      submitting = false;
      submitButton.disabled = false;
      if (!hasSent) submitButton.textContent = '로그인 링크 받기';
    }
  });

  async function submitOtc(event) {
    event.preventDefault();
    if (verifying || !otcRef || !otcInput || !otcSubmitButton) return;

    otcInput.value = otcInput.value.replace(/[^0-9]/g, '').slice(0, 6);
    if (!/^\d{6}$/.test(otcInput.value)) {
      setOtcFeedback('이메일에 표시된 6자리 인증 코드를 입력해 주세요.', true);
      otcInput.focus();
      return;
    }

    verifying = true;
    otcInput.disabled = true;
    otcSubmitButton.disabled = true;
    otcSubmitButton.textContent = '확인 중...';
    setOtcFeedback('', false);

    try {
      const integrityToken = await getIntegrityToken();
      const response = await fetch('/members/api/verify-otc/', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          otc: otcInput.value,
          otcRef,
          integrityToken
        })
      });

      if (response.status === 429) {
        setOtcFeedback('인증 시도가 많습니다. 잠시 후 다시 시도해 주세요.', true);
      } else if (!response.ok) {
        setOtcFeedback('인증 코드를 확인할 수 없거나 만료되었습니다. 코드를 확인하거나 새 로그인 링크를 요청해 주세요.', true);
      } else {
        const result = await response.json();
        const redirectUrl = new URL(result.redirectUrl, window.location.origin);
        if (redirectUrl.origin !== window.location.origin || !redirectUrl.pathname.endsWith('/members/')) {
          throw new Error('unexpected_ghost_signin_redirect');
        }

        // Ghost performs token exchange and creates the member session at this boundary.
        redirecting = true;
        window.location.assign(redirectUrl.href);
        return;
      }
    } catch (_) {
      setOtcFeedback('인증을 완료하지 못했습니다. 연결을 확인한 뒤 다시 시도해 주세요.', true);
    } finally {
      verifying = false;
      if (!redirecting) {
        otcInput.disabled = false;
        otcSubmitButton.disabled = otcInput.value.length !== 6;
        otcSubmitButton.textContent = '로그인';
      }
    }
  }
})();
